// 微信登陆及链接地址配置     

export default {
   title: "伊利集团互联网舆情监测系统",
   // wxCall_url: "https://gz.datastory.com",                       // 微信登陆回调地址             
   wxCall_url: "http://syzhfront.dev.datastory.com.cn",                       // 微信登陆回调地址             
   url: "https://enterprise.datastory.com.cn",              // iframe链接正式地址             
   dev_url: "http://192.168.20.57:8082",                    // iframe链接本地地址

   // appId: "wxcd03d6107a72cabe",                      // 微信登陆appid
   appId: "wxab451d75e2155a60",                      // 微信登陆appid
   projectType: 0,                                   // 项目标识    0=蓝鹰；1=企业版；2=数舆；3=伊利；4=大奥足协
}





/*
    各项目配置记录：
        蓝鹰：
           appId: "wx923faef77ff3f750"                     正式
           url: "https://lanying.datastory.com.cn"         正式
           appId: "wxab451d75e2155a60"                     测试
           url: "http://syzhfront.dev.datastory.com.cn"    测试
           projectType: 0,

        数舆：
           appId: "wx8ffcbf87e1610d56" 
           url: "http://gz.shuyudata.com"
           projectType: 2,

        伊利：
           appId: "wxcd03d6107a72cabe" 
           url: "https://yili.datastory.com.cn"
           projectType: 3,

        大奥足协：
           appId: "wx5462f56fefe5030c" 
           url: "http://zx.daaokj.cn"
           projectType: 4,
*/


// WEBPACK FOOTER //
// ./src/pages/config.js